module.exports = __webpack_public_path__ + "img/app.6fd39a68.png";